import { render, staticRenderFns } from "./merchantClass.vue?vue&type=template&id=5d5bcd0a&scoped=true"
import script from "./merchantClass.vue?vue&type=script&lang=js"
export * from "./merchantClass.vue?vue&type=script&lang=js"
import style0 from "./merchantClass.vue?vue&type=style&index=0&id=5d5bcd0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5bcd0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5bcd0a')) {
      api.createRecord('5d5bcd0a', component.options)
    } else {
      api.reload('5d5bcd0a', component.options)
    }
    module.hot.accept("./merchantClass.vue?vue&type=template&id=5d5bcd0a&scoped=true", function () {
      api.rerender('5d5bcd0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/detail-pane/merchantClass.vue"
export default component.exports